<div class="global-loader text-center">
  <div>
    <div class="spinner-grow text-loader-color" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="spinner-grow text-loader-color" role="status">
      <span class="sr-only">Loading...</span>
    </div>
    <div class="spinner-grow text-loader-color" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="loading-text text-loader-color">Launching...</div>
</div>
